import React from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import CodeBox from 'components/atoms/CodeBox'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { formatDate, LOCAL_DATE_FORMAT } from 'utils/date'
import * as popoverModule from 'modules/popover'

const styles = theme => ({
  root: {
    width: 400,
    height: 320,
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: `0 ${theme.spacing(1)}px`,
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  submitButton: {
    width: '100%',
  },
  controls: {
    width: 222,
    margin: '0 auto',
    marginBottom: 12,
  },
  description: {
    maxWidth: 250,
    margin: '0 auto',
  },
  codebox: {
    marginBottom: theme.spacing(6),
  },
})

class InviteCodePopover extends React.PureComponent {
  handleOkayClick = () => {
    this.props.actions.hidePopover()
  };

  render() {
    const { classes, code } = this.props

    return (
      <div className={classes.root}>
        <div>
          <Typography variant="h1" className={classes.title}>
            Your project code
          </Typography>
          <Typography className={classes.description}>
            Your code has been generated and will expire on:{' '}
            {formatDate(code.expireDate, LOCAL_DATE_FORMAT)}
          </Typography>
        </div>
        <div className={classes.controls}>
          <CodeBox className={classes.codebox} code={code.code} />
          <SubmitButton
            size="medium"
            type="submit"
            color="primary"
            variant="primary"
            onClick={this.handleOkayClick}
            className={classes.submitButton}>
            Okay
          </SubmitButton>
        </div>
      </div>
    )
  }
}

InviteCodePopover.propTypes = {
  code: PropTypes.object,
  actions: PropTypes.object,
  classes: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    code: idx(state, _ => _.organisation.selected.code),
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, popoverModule)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const InviteCodePopoverComponent = withStyles(styles)(InviteCodePopover)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteCodePopoverComponent)



// WEBPACK FOOTER //
// ./src/components/organisms/InviteCodePopover/InviteCodePopover.js